import React__default from 'react';
import { Menu } from '../../Menu/index.js';
import '../../Typography/src/Heading.js';
import '../../Typography/src/Link.js';
import '../../Typography/src/ListItem.js';
import '../../Typography/src/OrderedList.js';
import { Text } from '../../Typography/src/Text.js';
import '../../Typography/src/UnorderedList.js';

const defaultNotFoundText = 'К сожалению, по вашим параметрам ничего не найдено, попробуйте изменить их';
const EmptyContent = (props) => {
    const { emptyContent, ...rest } = props;
    return (React__default.createElement(Menu, { ...rest }, emptyContent || (React__default.createElement(Menu.Item, { disabled: true },
        React__default.createElement(Text, { className: "h-text-center h-color-D60" }, defaultNotFoundText)))));
};

export { EmptyContent, defaultNotFoundText };
//# sourceMappingURL=EmptyContent.js.map
